import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-710e2dfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { slot: "breadcrumbs" }
const _hoisted_2 = {
  dsf_level: "m-semibold",
  class: "dsf-hidden-mobile"
}
const _hoisted_3 = {
  dsf_level: "s-semibold",
  class: "dsf-hidden-tablet dsf-hidden-desktop"
}
const _hoisted_4 = {
  slot: "navigation",
  dsf_gap: "l"
}
const _hoisted_5 = ["dsf_open"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dsf-icon-button", {
  slot: "anchor",
  dsf_icon: "HelpCircle",
  dsf_size: "small"
}, null, -1 /* HOISTED */))

import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'

import { i18n } from '@/services/i18n'
import NotificationCenter from '@/notifications/NotificationCenter.vue'
import ProfileMenu from './ProfileMenu.vue'
import { ONBOARDING_ROUTE_NAME } from '@/config/routes'
import { analytics } from '@/services/analyticsProvider'
import { ANALYTICS_EVENTS } from '@/services/analyticsEvents'
import { useFaqUrl } from '@/components/sennderUrlHelper'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutHeaderNew',
  emits: ['mobile-menu-click'],
  setup(__props) {



const route = useRoute()

const headerText = computed(() => {
  if (route.name === ONBOARDING_ROUTE_NAME) {
    return ''
  }
  const key = `${String(route.name).toLowerCase()}.headline`
  return i18n.global.t(key)
})

const isHelpOpen = ref(false)

const faqUrl = useFaqUrl()

const navigateToFaq = () => {
  isHelpOpen.value = false
  window.open(faqUrl.value, '_blank')
  analytics.trackEvent(ANALYTICS_EVENTS.MENU_FAQ_CLICK)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("dsf-text", _hoisted_2, _toDisplayString(headerText.value), 1 /* TEXT */),
      _createElementVNode("dsf-text", _hoisted_3, _toDisplayString(headerText.value), 1 /* TEXT */)
    ]),
    _createElementVNode("dsf-row", _hoisted_4, [
      _createVNode(NotificationCenter),
      _createElementVNode("dsf-popover", {
        dsf_open: isHelpOpen.value,
        onOpenChanged: _cache[0] || (_cache[0] = (ev) => (isHelpOpen.value = ev.detail))
      }, [
        _hoisted_6,
        _createElementVNode("dsf-option", {
          class: "help-option",
          onClick: navigateToFaq
        }, "FAQ")
      ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5),
      _createCommentVNode(" Desktop profile "),
      _createVNode(ProfileMenu, { class: "dsf-hidden-mobile" }),
      _createCommentVNode(" Mobile navigation "),
      _createElementVNode("dsf-icon-button", {
        id: "hamburger",
        dsf_icon: "Menu",
        dsf_size: "medium",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('mobile-menu-click'))),
        class: "dsf-hidden-tablet dsf-hidden-desktop"
      })
    ])
  ]))
}
}

})